import { useEffect, useMemo } from 'react';

import { useSearchParams } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';

import { INPUT_MAX_LENGTH } from '@whelk/const';
import { DEFAULT_MODEL } from '@whelk/const/src/models';
import { CHAT_ID } from '@whelk/const/src/routerUrl';
import { FeatureType } from '@whelk/services/src/type/chat';
import { AppDispatch, RootState } from '@whelk/store';
import {
  setSelectedModel,
  setSelectModelTip,
  setShowVl01,
  setVL01Tip,
} from '@whelk/store/slices/localSlice';

const useChatModel = () => {
  const dispatch: AppDispatch = useDispatch();

  const searchParams = useSearchParams();
  const selectedChatID = searchParams?.get(CHAT_ID) || '';
  const isChatPage = !!selectedChatID;

  const { model, hasShownSelectModelTip, hasShownVL01Tip, isShowVl01 } = useSelector(
    (state: RootState) => state.local,
  );
  const chatModelList = useSelector((state: RootState) => state.config.chatModelList);
  const currentChatModel = chatModelList?.find((item) => item.value === model);

  useEffect(() => {
    // 旧数据兼容

    // 兼容 如果展示过VL-01，但是弹窗没有关闭，需要关闭
    if (hasShownVL01Tip && isShowVl01) {
      dispatch(setShowVl01(false));
    }

    // 判断页面的refer是否来自github 或者 HuggingFace
    const refer = document.referrer;

    if (
      (refer.includes('github') || refer.includes('huggingface')) &&
      !hasShownVL01Tip &&
      !isChatPage
    ) {
      dispatch(setShowVl01(true));
      dispatch(setVL01Tip(true)); // 如果展示过VL-01则把标识改为展示过

      if (DEFAULT_MODEL !== model) {
        // vl-01 需要切换成mmx模型
        dispatch(setSelectedModel(DEFAULT_MODEL));
      }
    }
  }, []);

  useEffect(() => {
    // 展示后关闭提示
    if (isShowVl01 && isChatPage) {
      closeVL01Tip();
    }
  }, [isChatPage]);

  // 是否可以上传图片
  const canUploadImage = useMemo(() => {
    return !currentChatModel?.disabled_features?.includes(FeatureType.UPLOAD_IMAGE);
  }, [currentChatModel]);

  // 是否有搜索模式
  const canSearchModel = useMemo(() => {
    return !currentChatModel?.disabled_features?.includes(FeatureType.SEARCH_MODE);
  }, [currentChatModel]);

  // 最大输入长度
  const maxInputLength = useMemo(() => {
    return currentChatModel?.max_input || INPUT_MAX_LENGTH;
  }, [currentChatModel]);

  // 关闭模型切换提示
  const closeModelTip = () => {
    dispatch(setSelectModelTip(true));
    if (isShowVl01) {
      closeVL01Tip();
    }
  };

  // 关闭VL01提示
  const closeVL01Tip = () => {
    dispatch(setVL01Tip(true));
    dispatch(setShowVl01(false));

    // 如果展示过 切换模型弹窗也不展示了
    dispatch(setSelectModelTip(true));
  };

  // // 设置当前模型，userSelect是表示是否是用户主动选择切换，记录到本地
  // const setModel = (value: string) => {
  //   dispatch(setSelectedModel(value));
  // };

  return {
    isShowModelTip: !hasShownSelectModelTip && !isShowVl01,
    isShowVl01: isShowVl01 && !isChatPage,
    modelName: currentChatModel?.label,
    ModelIcon: currentChatModel?.img,
    model,
    currentChatModel,
    canUploadImage,
    canSearchModel,
    maxInputLength,
    modelOptions: chatModelList,
    // setModel,
    closeModelTip,
    closeVL01Tip,
  };
};
export default useChatModel;
